import { PropertyKind } from '@/constants';
import type { IAddressBase } from '@/interfaces';
import { FormValidations } from '@/utils';

export function AddressFormSchema(address: IAddressBase, propertyKind?: PropertyKind) {
	const kind = propertyKind ?? (address as any)?.propertyKind;
	const isAdditionalRequired =
		kind === PropertyKind.Apartment || kind === PropertyKind.Loft ||
		kind === PropertyKind.Studio ||
		kind === PropertyKind.CommercialStore ||
		kind === PropertyKind.CommercialOffice;
	return {
		zipCode: [FormValidations.IsRequired],
		streetName: [FormValidations.IsRequired],
		number: [FormValidations.IsRequired],
		city: [FormValidations.IsRequired],
		district: [FormValidations.IsRequired],
		state: [FormValidations.IsRequired],
		...(isAdditionalRequired ? { additional: [FormValidations.IsRequired] } : {}),
	};
};

export default AddressFormSchema;
